import map from "lodash/map"
import find from "lodash/find"
import get from "lodash/get"
import { useState } from "react"
import Box from "component-lib/Base/components/Box"
import { Typography } from "component-lib/Base/components/Typography/Typography"
import { ReactSVG } from "react-svg"
import { makeStyles } from "tss-react/mui"
import getContentUrl from "utils-lib/getContentUrl"
import { Button, ButtonArrow } from "../../../../../Base"
import MegaNavSection from "../../../MegaNav/components/MegaNavSection"
import MenuItem from "../../../BottomHeader/components/MenuItem/MenuItem"

const useStyles = makeStyles()((_theme, { isHeaderMobile }) => ({
  sectionContainer: {
    width: isHeaderMobile ? "375px" : "100%",
    padding: `0 20px`,
  },
  firstSectionContainer: {
    marginTop: isHeaderMobile ? "88px" : "0px",
    marginBottom: "26.5px",
  },
  secondLevelSectionContainer: {
    height: 0,
    marginTop: 0,
    overflow: `hidden`,
    transition: `0.3s all`,
  },
  searchWrapper: {
    height: `85px`,
    position: isHeaderMobile ? "fixed" : "relative",
    width: isHeaderMobile ? "304px" : "90%",
  },
  openSecondLevel: {
    height: `auto`,
  },
  searchButton: {
    background: `$Sand`,
    borderRadius: 4,
    color: `#767676`,
    fontSize: `0.825rem`,
    textIndent: `0.625rem`,
    height: isHeaderMobile ? "50px" : "40px",
  },
  columnPadding: {
    paddingLeft: `2rem`,
    marginTop: `1.5rem`,
  },
  subHeadingTitle: {
    fontSize: `1.25rem !important`,
    lineHeight: "1.5rem",
  },
  secondLevelLinkTitle: {
    fontSize: "1rem",
    lineHeight: `1.5rem`,
  },
  paddingBottomRemover: {
    paddingBottom: `0 !important`,
  },
}))

const RedesignedHeaderNavItems = ({
  onMenuClick,
  navigationDetails,
  setParentState,
  setIsSearchOpen = () => {},
  isHeaderMobile = false,
  searchPlaceholder = `Search`,
  isMenuOpen = false,
}) => {
  const [megaNavSubviewSelection, setMegaNavSubviewSelection] = useState(``)

  const { classes } = useStyles({ isHeaderMobile })

  const getTabIndex = () => {
    if (isHeaderMobile) {
      if (isMenuOpen) {
        return "0"
      }
      return "-1"
    }
    return "0"
  }

  const renderMegaNavSection = (links, tabIndex) => (
    <MegaNavSection
      links={links}
      setParentState={setParentState}
      onMenuClick={onMenuClick}
      customFont={classes.secondLevelLinkTitle}
      customClass={classes.paddingBottomRemover}
      tabIndex={tabIndex}
    />
  )

  const renderDetails = (data) => {
    const shouldShow =
      get(data, `firstLevelNavigationText`, ``) === megaNavSubviewSelection

    const activeHeaderOption = find(
      navigationDetails,
      (item) =>
        get(item, `firstLevelNavigationText`, ``) === megaNavSubviewSelection,
    ) || { secondLevelSections: [] }

    const isSelected =
      megaNavSubviewSelection === get(data, `firstLevelNavigationText`, ``)
        ? "0"
        : "-1"

    return (
      <Box
        className={`${classes.secondLevelSectionContainer} ${
          shouldShow && classes.openSecondLevel
        }`}
        aria-hidden={!shouldShow}
      >
        {map(activeHeaderOption.secondLevelSections, (section) => (
          <Box className={`${classes.columnPadding} column`}>
            <Typography
              component="h4"
              className={`${classes.subHeadingTitle} column-title maax-font-weight-bold wm-link-light-green`}
            >
              {get(section, `secondLevelHeading`, ``)}
            </Typography>
            {renderMegaNavSection(section.secondLevelItems, isSelected)}
            {section.ctaText ? (
              <ButtonArrow
                isExternalLink={section.isExternalLink}
                href={get(section, `ctaLink`, ``)}
                target="_blank"
                rel="noopener noreferrer"
                key="1"
                justification="justify-content-start"
                className="maax-font-weight-bold quick-items pb-2"
                onClick={() => {
                  onMenuClick(false)
                }}
                testid="RedesignedHeaderNavItems-ArrowButton"
                tabIndex={isSelected}
              >
                {get(section, `ctaText`, ``)}
              </ButtonArrow>
            ) : null}
          </Box>
        ))}
      </Box>
    )
  }

  return (
    <Box className="subMenuItems d-flex" data-testid="RedesignedHeaderNavItems">
      <Box className={classes.sectionContainer}>
        <div className={`bg-white pt-2 ${classes.searchWrapper} `}>
          <Button
            tabIndex={getTabIndex()}
            overrideClass={`MobileNavItems__search-icon d-flex align-items-center w-100 wm-border-gray bg-white ${classes.searchButton}`}
            fontClass="maax-font-weight-regular"
            onClick={() => {
              setIsSearchOpen(true)
            }}
            testid="RedesignedHeader-SearchButton"
          >
            <ReactSVG
              wrapper="span"
              src={getContentUrl("/content/dam/wm/icons/search-icon.svg")}
              className="react-svg"
            />
            <Box>{searchPlaceholder}</Box>
          </Button>
        </div>
        <Box
          className={`nav-links overflow-auto ${classes.firstSectionContainer} `}
        >
          {navigationDetails.map((menuItem, index) => (
            <Box key={index}>
              <MenuItem
                {...menuItem}
                onMegaNavSelection={onMenuClick}
                onMegaNavSubviewSelection={(selection) => {
                  setMegaNavSubviewSelection(
                    megaNavSubviewSelection ===
                      menuItem.firstLevelNavigationText
                      ? null
                      : selection,
                  )
                }}
                megaNavSelection={megaNavSubviewSelection}
                isNewDashboard
                tabIndex={getTabIndex()}
              />
              {renderDetails(menuItem)}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

// // Note: React 19 no-longer supports propTypes. Leaving this for reference.
// RedesignedHeaderNavItemsLegacy.propTypes = {
//   onMenuClick: PropTypes.func.isRequired,
//   navigationDetails: PropTypes.array.isRequired,
//   // unused prop, removed from the migrated component
//   firstLevelNavigationText: PropTypes.array.isRequired,
//   // unused prop, removed from the migrated component
//   userDetails: PropTypes.object.isRequired,
//   setParentState: PropTypes.func.isRequired,
//   // unused prop, removed from the migrated component
//   isLoggedIn: PropTypes.bool.isRequired,
//   // unused prop, removed from the migrated component
//   logOut: PropTypes.func.isRequired,
//   // unused prop, removed from the migrated component
//   language: PropTypes.string.isRequired,
//   setIsSearchOpen: PropTypes.func,
//   isHeaderMobile: PropTypes.bool,
//   searchPlaceholder: PropTypes.string,
//   isMenuOpen: PropTypes.bool,
// }

// // Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// RedesignedHeaderNavItemsLegacy.defaultProps = {
//   setIsSearchOpen: () => {},
//   isHeaderMobile: false,
//   searchPlaceholder: `Search`,
//   isMenuOpen: false,
// }

export default RedesignedHeaderNavItems
